import {
  AD_PLACEMENTS,
  AD_UNIT_ID,
  ALLOCATION_TYPE,
  allocationGroups,
  BILLING_EVENT,
  INVENTORY_TYPE,
  INVENTORY_TYPE_AD_PLACEMENTS,
  IS_SUB_ALLOCATION,
  PLACEMENT_ID
} from './sectionsLists/OnsiteRightCreateSections/fields'
import {
  getBillingEventType,
  getFilteredAdUnits
} from './sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import { ALLOCATION } from '../../fields'

// Helper function to format a single inventory item (placement or ad unit)
const formatInventoryItemToBE = ({ item, gamNetworkCode, billingEventType, rate, isPlacement }) => {
  return {
    network_code: gamNetworkCode,
    [isPlacement ? PLACEMENT_ID : AD_UNIT_ID]: item.id,
    name: item.name,
    ...(item.description && { description: item.description }),
    prices: {
      [billingEventType]: rate || 0
    }
  }
}

// Helper function to transform a single inventory item (placement or ad unit) for sub-allocation
const transformInventoryItemToBE = ({ item, isPlacement, allocationType }) => {
  const allocationGroup = allocationGroups[allocationType]

  return {
    [isPlacement ? PLACEMENT_ID : AD_UNIT_ID]: item.id,
    [ALLOCATION]: item[allocationGroup][ALLOCATION]
  }
}

export const formatAdInventoryToBE = (values, gamNetworkCode) => {
  // The JSON array of ad_inventory field has both placement_id and ad_unit_id field.
  // For any one JSON in the array either placement_id is filled and ad_unit_id is empty, or vice verse.
  // As the rightsholder can define the ad inventory they make accessible to the sponsor either in terms of GAM placements or in terms of GAM ad units,
  // the ad_inventory JSON array will either be made up of all placement JSONs or all ad units JSONs.
  const billingEventType = getBillingEventType(values[ALLOCATION_TYPE], values[BILLING_EVENT])

  // For single allocation, use the single rate for all ad inventory
  if (!values[IS_SUB_ALLOCATION]) {
    const singleRate = values[billingEventType] || 0

    if (values[INVENTORY_TYPE] === INVENTORY_TYPE_AD_PLACEMENTS) {
      return values[AD_PLACEMENTS].map(placement =>
        formatInventoryItemToBE({
          item: placement,
          gamNetworkCode,
          billingEventType,
          rate: singleRate,
          isPlacement: true
        })
      )
    } else {
      const filteredAdUnits = getFilteredAdUnits(values)
      return filteredAdUnits.map(adUnit =>
        formatInventoryItemToBE({
          item: adUnit,
          gamNetworkCode,
          billingEventType,
          rate: singleRate,
          isPlacement: false
        })
      )
    }
  }

  // For sub-allocation, use individual rates for each ad inventory
  if (values[INVENTORY_TYPE] === INVENTORY_TYPE_AD_PLACEMENTS) {
    return values[AD_PLACEMENTS].map(placement =>
      formatInventoryItemToBE({
        item: placement,
        gamNetworkCode,
        billingEventType,
        rate: placement[billingEventType],
        isPlacement: true
      })
    )
  } else {
    const filteredAdUnits = getFilteredAdUnits(values)
    return filteredAdUnits.map(adUnit =>
      formatInventoryItemToBE({
        item: adUnit,
        gamNetworkCode,
        billingEventType,
        rate: adUnit[billingEventType],
        isPlacement: false
      })
    )
  }
}

export const transformSubAllocationsToBE = values => {
  // For single allocation, return an empty array
  if (!values[IS_SUB_ALLOCATION]) {
    return []
  }

  const allocationType = values[ALLOCATION_TYPE]

  // For sub-allocation, return the allocation for each ad inventory
  if (values[INVENTORY_TYPE] === INVENTORY_TYPE_AD_PLACEMENTS) {
    return values[AD_PLACEMENTS].map(placement =>
      transformInventoryItemToBE({
        item: placement,
        isPlacement: true,
        allocationType
      })
    )
  } else {
    const filteredAdUnits = getFilteredAdUnits(values)

    return filteredAdUnits.map(adUnit =>
      transformInventoryItemToBE({
        item: adUnit,
        isPlacement: false,
        allocationType
      })
    )
  }
}
